import { useSyncExternalStore } from "react";
import { getHeldSignupToken, isSignupHash, subscribeSignupToken } from "@/lib/signup-route";

function subscribeHash(callback: () => void): () => void {
  // Токен из адреса забирает перехватчик `watchSignupHash` из `main.tsx`: он
  // стоит на стадии погружения и срабатывает раньше этой подписки и раньше
  // слушателей экрана. Здесь — только подписка на смену состояния.
  window.addEventListener("hashchange", callback);
  return () => window.removeEventListener("hashchange", callback);
}

function getActive(): boolean {
  return isSignupHash(window.location.hash);
}

/**
 * Маршрут регистрации (`#/signup`, `#/signup/{token}`): открыта ли страница и
 * какой токен ссылки принесён. Читается из адреса и разбирается до проверки
 * сессии; сам токен лежит в памяти, а из адреса убран (`signup-route.ts`).
 */
export function useSignupRoute(): { active: boolean; token: string | null } {
  const active = useSyncExternalStore(subscribeHash, getActive);
  const token = useSyncExternalStore(subscribeSignupToken, getHeldSignupToken);
  return { active, token };
}
